import classnames from 'classnames/bind'
import { useTranslate } from 'react-polyglot'
import { Variant } from '~/@types/product'

import { CloseIcon, PreOrderIcon } from '~/components/UI/Icons'
import Image from '~/components/UI/Image'
import { PreviewLoader } from '~/components/UI/PreviewLoader'

import { CUSTOMIZER } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)
export interface VariantImageSelectorProps {
  className?: string
  imgClassName?: string
  item: Variant
  active: boolean
  onClick?(string): void
  withClose?: boolean
  isLoading?: boolean
  ariaLabel?: string
}
const IMAGE_SIZES = [{ breakpoint: 'lg', ratio: 2 / 24 }, { ratio: 1 / 5 }]
export function VariantImageSelector({
  className,
  imgClassName,
  item,
  active,
  ariaLabel,
  onClick,
  withClose,
}: VariantImageSelectorProps) {
  const t = useTranslate()

  return (
    <button
      aria-label={t(CUSTOMIZER.SELECT_VARIANT, { product: ariaLabel })}
      className={cx(css.VariantImageSelector, { active }, className)}
      onClick={() => {
        onClick(item?.id)
      }}>
      {active && withClose && (
        <div className={cx(css.close)}>
          <CloseIcon />
        </div>
      )}

      {active && <PreviewLoader className={cx(css.loader)} />}

      {item?.isBundleProductPreOrder && (
        <PreOrderIcon className={css.preOrderIcon} />
      )}

      <Image
        className={cx(css.image, imgClassName)}
        ratio={1}
        sizesFromBreakpoints={IMAGE_SIZES}
        layout="fill"
        asPlaceholder
        draggable="false"
        objectFit="cover"
        loader={null}
        {...item?.image}
      />
    </button>
  )
}
